// var local = new setLocalizations([{ Culture: CULTURE, Name: NATIVELANGUAGENAME [, EnglishName: ENGLISHNAME, IsActive= BOOL]},
// have to call with new.. see example below
//var local = new setLocalizations([
//    { Culture: "da-DK", EnglishName: "Danish", Name: "Dansk"},
//    { Culture: "en-US", EnglishName: "English", Name: "English", IsActive: true },
//    { Culture: "fi-FI", EnglishName: "Finnish", Name: "Suomi"},
//    { Culture: "nn-NO", EnglishName: "Norwegian", Name: "Norsk (nynorsk)"},
//    { Culture: "nb-NO", EnglishName: "Norwegian", Name: "Norsk (bokmål/riskmål)"},
//    { Culture: "sv-se", EnglishName: "Swedish", Name: "Svenska" }
//], $('.unify-nav-right > li:first'));

import 'jquery';
import { Cookie } from './cookie.js';

export class LanguageChooser {

    /**
    * setLocalizations is function that calls the function that sets localization chooser at the top bar
    * @param {undefined|object} json is the localization content in json format.
    * @example call
    *  setLocalizations( [
    *   { "Culture": "da-DK", "EnglishName": "Danish", "Name": "Dansk" },
    *   { "Culture": "en-US", "EnglishName": "English","Name": "English", "IsActive": true }
    *  ] );
    */
    setLocalizations(json) {
        var languageDiv = $('.unify-header-flex-right > div.unify-header-language');
        $('ul', languageDiv).remove();

        if (typeof json === "undefined" || json === null) {
            // hide the globe
            $('#language-drop', languageDiv).addClass('unify-hidden');
            return;
        }

        // ensure globe visible by removing possible unify-hidden on 
        $('#language-drop', languageDiv).removeClass('unify-hidden');

        // create the language dropdown and set the global language object
        this.createSelect(json, languageDiv);
        this.updateLanguageDropIcon();
        this.setComponentsLanguageDefaults();
    }

    updateLanguageDropIcon() {
        var iconUrl = this.activeLocalization.IconUrl;

        $('#language-drop-icon').attr('src', iconUrl);
    }

    setComponentsLanguageDefaults() {
        // get current culture from the glboal localizaion object
        var culture = this.activeLocalization.Culture;

        this.setDataTablesDefaultLanguage(culture);
    }

    // this should probably be moved from here to... jquery library?
    setDataTablesDefaultLanguage(culture) {
        var language;
        switch (culture) {
            case 'en-US':
            case 'en-UK':
                language =
                    {
                        "emptyTable": "No data available in table",
                        "info": "Showing _START_ to _END_ of _TOTAL_ entries",
                        "infoEmpty": "Showing 0 to 0 of 0 entries",
                        "infoFiltered": "(filtered from _MAX_ total entries)",
                        "infoPostFix": "",
                        "infoThousands": ",",
                        "lengthMenu": "Show _MENU_ entries",
                        "loadingRecords": "Loading...",
                        "processing": "Processing...",
                        "search": "Search:",
                        "zeroRecords": "No matching records found",
                        "paginate": {
                            "first": "First",
                            "last": "Last",
                            "next": "Next",
                            "previous": "Previous"
                        },
                        "aria": {
                            "sortAscending": ": activate to sort column ascending",
                            "sortDescending": ": activate to sort column descending"
                        }
                    }
                break;
            case 'sv-SE':
            /* falls through */
            default:
                language = {
                    "emptyTable": "Tabellen innehåller ingen data",
                    "info": "Visar _START_ till _END_ av totalt _TOTAL_ rader",
                    "infoEmpty": "Visar 0 till 0 av totalt 0 rader",
                    "infoFiltered": "(filtrerade från totalt _MAX_ rader)",
                    "infoPostFix": "",
                    "infoThousands": " ",
                    "lengthMenu": "Visa _MENU_ rader",
                    "loadingRecords": "Laddar...",
                    "processing": "Bearbetar...",
                    "search": "Sök:",
                    "zeroRecords": "Hittade inga matchande resultat",
                    "paginate": {
                        "first": "Första",
                        "last": "Sista",
                        "next": "Nästa",
                        "previous": "Föregående"
                    },
                    "aria": {
                        "sortAscending": ": aktivera för att sortera kolumnen i stigande ordning",
                        "sortDescending": ": aktivera för att sortera kolumnen i fallande ordning"
                    }
                }
        }
        if (typeof $.fn.dataTable !== "undefined") {
            $.extend(true, $.fn.dataTable.defaults, {
                "language": language
            });
        }
    }

    createSelect(langItems, domElement) {
        this.activeLocalization = null;
        this.cookie = new Cookie();
        if (typeof langItems === "undefined" || langItems === null ||
            typeof domElement === "undefined" || domElement === null
        ) {
            // do nothing
            return;
        }

        this.langItems = langItems;
        this._render(this.langItems, domElement);

        // set active from first 'IsActive'
        var activeLangItem = this._getActiveElementFromLangItems(this.langItems);
        activeLangItem = activeLangItem != null ? activeLangItem : langItems[0];
        this._setActive(activeLangItem);
    }

    get currentCulture() {
        return this.activeLocalization.Culture;
    }

    _render(langItems, domElement) {
        if (langItems == null || typeof langItems === 'undefined') {
            return;
        }

        var ul = document.createElement("ul");
        $(ul).addClass("dropdown-menu");
        $(ul).addClass("dropdown-menu-right");
        $(ul).addClass("unify-dropdown-language");
        $(ul).attr("id", "unify-languagepicker-dropdown");
        //<ul class="dropdown-menu ropdown-menu-right unify-dropdown-language">
        //    <li>
        //        <div class="radio unify-language-chooser">
        //            <input type="radio" name="radioLanguageChooser" id="radioLanguageda" class="unify-language-chooser-input" value="da">
        //            <label for="radioLanguageda">Dansk</label>
        //        </div>
        //    </li>
        //</ul>

        for (var i = 0, nr = langItems.length; i < nr; i++) {
            var lang = langItems[i];
            var li = document.createElement("li");
            var div = document.createElement("div");
            $(div).addClass("radio");
            $(div).addClass("unify-language-chooser");

            var inputId = "radio-language-" + lang.Culture;

            var input = document.createElement("input");
            $(input).addClass("unify-language-chooser-input");
            $(input).prop("id", inputId);
            $(input).prop("type", "radio");
            $(input).prop("name", "unify-radio-language-chooser");

            var label = document.createElement("label");
            $(label).prop("for", inputId);
            $(label).html(lang.Name);

            // add click on li
            var that = this;
            $(li).on("click", function (e) { that._cultureLanguageChange(this, e); });

            // add click on label, that prevents bouble (label click will trigger browser click on radiobutton)
            $(label).on("click", function (e) { that._labelClicked(this, e); });

            $(div).append(input);
            $(div).append(label);
            $(li).append(div);
            $(ul).append(li);

            // set domElement to make it possible to find with _findItemFromElement
            lang.domElement = li;
        }

        $(domElement).append(ul);
    }

    _getActiveElementFromLangItems() {
        for (var i = 0, nr = this.langItems.length; i < nr; i++) {
            var lang = this.langItems[i];
            if (typeof lang.IsActive !== "undefined" && !!lang.IsActive) {
                return lang;
            }
        }
        return null;
    }

    // a overridable function that decides what to do when language has been changed
    // should return if page should be reloaded or not
    onLocalizationChange(currentCulture) {
        if (this.onLocalizationChangedIsSet() === true) {
            //return this.onLocalizationChanged();
            var handled = this.onLocalizationChanged(this.currentCulture);
            return handled;
        }
        return false;
    }

    onLocalizationChangedIsSet() {
        return false;
    }

    // if this function returns true, it will not reload
    // this function is overloaded by setting window.unify.onLocalizationChange,
    // should be placed with function instead window.unify.localization.setOnlocalizationChange(FUNCTION);
    onLocalizationChanged() {
        return false;
    }

    _cultureLanguageChange(li, event) {
        var liItem = this._findItemFromElement(this.langItems, li);
        // set cookie UN_CLT with value of culture, the cookie should be scoped to top domain, make it valid for 12 months..
        var cookieName = 'UN_CLT';
        var cookieValue = liItem.Culture;
        var days = 365;
        this.cookie.set(cookieName, cookieValue, days);

        this._setActive(liItem);

        var handled = this.onLocalizationChange(this.currentCulture);
        if (handled) {
            // do nothing
        } else {
            // default reload page
            location.reload();
        }
    }

    _labelClicked(label, event) {
        // stop change language to trigger twice when clicking label
        event.stopPropagation();
    }

    _findItemFromElement(items, element) {
        if (items == null || typeof items === "undefined") {
            return null;
        }

        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item.domElement === element) {
                return item;
            }
        }

        return null;
    }

    _setActive(newActiveLangItem) {
        var i, nr, lang;
        // remove old
        for (i = 0, nr = this.langItems.length; i < nr; i++) {
            lang = this.langItems[i];
            lang.IsActive = null;
        }

        for (i = 0, nr = this.langItems.length; i < nr; i++) {
            lang = this.langItems[i];
            if (lang === newActiveLangItem) {
                lang.IsActive = true;
                this.activeLocalization = lang;
                $("input", lang.domElement).prop("checked", true);
            }
        }
    }
}

